<template>
	<div class="brick">
		<div class="list_top_box">
			<table border="0">
				<tr>
					<td style="width: 80%;">
						<div class="left_option">
							<!-- <em class="lt_text">Trans Date</em> -->
							<span class="mgr_5"> <CustomDatePicker v-model="trans_date_from"/> ~ <CustomDatePicker v-model="trans_date_to"/></span>
							<span v-if="profile.use_temp_flag == 'Y'" class="int_type_no_border">
								<!-- <select v-model="designation_type" class="tbl_select" style="width:140px;" :disabled="status_code != 'O' && status_code != 'A' && status_code != 'P'"> -->
								<select v-model="temp_flag" class="tbl_select" style="width:80px;" @change="search(true)">
									<option :value="null">All</option>
									<option :value="0">NJ Only</option>
									<option :value="1">GA Only</option>
								</select>
							</span>

							<em class="lt_text">S. Grp.</em>
							<span class="int_type_no_border mgr_5"><CodeSelect className="tbl_select" :codes="salesGroups" :descWidth="130" v-model="sales_group_code"/></span>

							<em class="lt_text">D. Type</em>
							<span class="int_type_no_border mgr_5"><CodeSelect className="tbl_select" :codes="deliveryTypes" :descWidth="130" v-model="delivery_type_code"/></span>

							<em class="lt_text">Print Unit T.</em>
							<input type="text" v-model.trim="so_dn_unit_ticket" class="tbl_int" style="width:125px;" placeholder="Enter SO No or Scan" @keypress.enter="unitTicketModal()" @focus="$event.target.select()" />

							<a v-if="status_code === 'A'" href="javascript:void(0);" type="button" class="gray_bt2" style="background:yellow;margin-left:10px;" @click="wholeTicketPrint()">Whole Ticket</a>
							<a v-if="status_code === 'A'" href="javascript:void(0);" type="button" class="gray_bt2" style="margin-left:5px;" @click="printPickingTicket(true)">Picking Ticket</a>

							<a v-if="status_code === 'P'" href="javascript:void(0);" type="button" class="gray_bt2" style="background:yellow;margin-left:10px;" @click="wholeTicketPrint()">Reprint W. T.</a>
							<a v-if="status_code === 'P'" href="javascript:void(0);" type="button" class="gray_bt2" style="margin-left:5px;" @click="printPickingTicket(false)">Reprint P. T.</a>
							<a v-if="status_code === 'A'" href="javascript:void(0);" type="button" class="gray_bt2" @click="packingBox(true)">Packing Box</a>
						</div>
						<div class="left_option" style="margin-top:2px;">
							<span class="int_type_no_border mgr_5">
								<PartnerSelect v-model="customer_code" ph="Ship / Bill To" :customerOnly="true" :showName="false" @set-partner="setPartner" />
							</span>

							<!-- <em class="lt_text">Country</em> -->
							<span class="int_type_no_border">
								<select v-model="country_type" class="tbl_select" style="width:90px;">
									<option :value="null">All Country</option>
									<option value="US">US Only</option>
									<option value="NON_US">Non US</option>
								</select>
							</span>

							<template v-if="user.company_id == 'beautyplus' || user.company_id == 'hairplus'">
								<em class="lt_text">State</em>
								<span class="int_type_no_border mgr_5"> <CodeSelect :width="70" :codeWidth="120" :showDesc="false" :codes="filteredStates" v-model="state" :disabled="!country_type" /> </span>
							</template>

							<!-- <em v-show="false" class="lt_text">Item {{ headers.class }}</em>
							<span v-show="false" class="int_type_no_border mgr_5"> <ItemClassSelect v-model="itemClass" :showName="true" /> </span> -->

							<item-class-select-multi-s style="display:inline-block;" ref="ItemClassSelectMultiS" :multiSelect="true" v-model="itemClasses" />
						</div>
						<div class="left_option" style="margin-top:-5px;">
							<!-- <em class="lt_text">SO No</em> -->
							<span class="int_type_no_border">
								<!-- <input type="text" v-model.trim="sono" placeholder="Enter SO No or Scan Barcode" autofocus autocomplete="off" /> -->
								<!-- <SoSelect v-model.trim="so_dn" initialStatusCode="P" ph="Enter SO No or Scan Barcode" @set-invoice="setInvoice" @search="search()" /> -->
								<SoSelect v-model.trim="so_dn" ph="Enter No or Scan" style="width:125px;" @set-invoice="setInvoice" @search="search(true)" />
							</span>

							<span v-if="user.company_id == 'beautyplus'" class="int_type_no_border">
								<!-- <select v-model="designation_type" class="tbl_select" style="width:140px;" :disabled="status_code != 'O' && status_code != 'A' && status_code != 'P'"> -->
								<select v-model="designation_type" class="tbl_select" style="width:140px;">
									<option :value="null">Reg. & Designated</option>
									<option :value="0">Regular Only</option>
									<option :value="1">Designated Only</option>
								</select>
							</span>

							<a href="javascript:;" class="search_bt" @click="search(true)">Search</a>
							<a href="javascript:;" class="gray_bt" @click="reset()">Reset</a>
							<span>O<span v-if="user.company_id != 'beautyplus'"> / H </span> / A / Packing / Packed<span v-if="user.company_id != 'beautyplus'"> / P.H</span> / I<template v-if="user.company_id == 'beautyplus'">nvoice</template></span>
							<currency-input type="text" v-model="open_sum" :precision="0" style="color:blue;" class="r_int ssm_int al_right" readonly />
							<currency-input v-if="user.company_id != 'beautyplus'" type="text" v-model="hold_sum" :precision="0" style="color:black;" class="r_int ssm_int al_right" readonly />
							<currency-input type="text" v-model="approved_sum" :precision="0" style="color:red;" class="r_int ssm_int al_right" readonly />
							<currency-input type="text" v-model="packing_sum" :precision="0" style="color:red;" class="r_int ssm_int al_right" readonly />
							<currency-input type="text" v-model="packed_sum" :precision="0" style="color:red;" class="r_int ssm_int al_right" readonly />
							<currency-input v-if="user.company_id != 'beautyplus'" type="text" v-model="packed_hold_sum" :precision="0" style="color:black;" class="r_int ssm_int al_right" readonly />
							<currency-input type="text" v-model="invoice_sum" :precision="0" style="color:red;" class="r_int ssm_int al_right" readonly />

							<!-- <span v-if="user.company_id == 'beautyplus' && temp_invoices.length > 0" class="mgl_15"
								><a href="javascript:;" @click="openTempInvoices()"
									><font color="red">{{ temp_invoices.length }} Temp Sales Order(s)</font></a
								></span
							> -->
						</div>
						<div class="left_option">
							<span class="int_type_no_border mgr_10" style="padding-top:5px;">
								<label class="mgr_10"
									><input type="radio" value="O" v-model="status_code" v-on:change="search(true)" /> <span :style="open_count > 0 ? 'font-weight:bold;color:red;' : ''">Open ({{ open_count | commaSeparated }})</span></label
								>
								<label class="mgr_10"
									><input type="radio" value="H" v-model="status_code" v-on:change="search(true)" /> <span :style="hold_count > 0 ? 'font-weight:bold;color:red;' : ''">Hold ({{ hold_count | commaSeparated }})</span></label
								>
								<label class="mgr_10"
									><input type="radio" value="A" v-model="status_code" v-on:change="search(true)" /> <span :style="approved_count > 0 ? 'font-weight:bold;color:red;' : ''">Approved ({{ approved_count | commaSeparated }})</span></label
								>
								<label class="mgr_10"
									><input type="radio" value="P" v-model="status_code" v-on:change="search(true)" /> <span :style="packing_count > 0 ? 'font-weight:bold;color:red;' : ''">Packing ({{ packing_count | commaSeparated }})</span></label
								>
								<label class="mgr_10"
									><input type="radio" value="W" v-model="status_code" v-on:change="search(true)" /> <span :style="packed_count > 0 ? 'font-weight:bold;color:red;' : ''">Packed ({{ packed_count | commaSeparated }})</span></label
								>
								<label class="mgr_10"
									><input type="radio" value="PH" v-model="status_code" v-on:change="search(true)" />
									<span :style="packed_hold_count > 0 ? 'font-weight:bold;color:red;' : ''">Packed Hold({{ packed_hold_count | commaSeparated }})</span></label
								>
								<label class="mgr_10"
									><input type="radio" value="I" v-model="status_code" v-on:change="search(true)" /> <span :style="invoice_count > 0 ? 'font-weight:bold;color:red;' : ''">Invoice ({{ invoice_count | commaSeparated }})</span></label
								>
								<label class="mgr_10"
									><input type="radio" value="Sample" v-model="status_code" v-on:change="search(true)" /> <span :style="sample_count > 0 ? 'font-weight:bold;color:red;' : ''">Sample ({{ sample_count | commaSeparated }})</span></label
								>
							</span>

							<span style="margin-top:5px;display:inline-block;">
								<input type="checkbox" v-model="auto_refresh" @change="setAutoRefresh()" />
								Auto Refresh
								<template v-if="last_search_time">
									<!-- <span>, refreshes every 1 minute</span> -->
									, <span :style="over_1_minute ? 'color:red;font-weight:bold;' : ''">{{ last_search_time | moment('HH:mm:ss') }}</span>
								</template>
								<!-- <template v-else> , <span>No Search</span> </template> -->
							</span>

							<span v-if="status_code == 'I' && user.company_id == 'beautyplus' && profile.use_temp_flag == 'Y' && user.temp_flag" style="margin-top:5px;display:inline-block;margin-left:15px;">
								<input type="checkbox" v-model="wh_not_printed" @change="search(true)" />
								WH Not Printed
							</span>

							<span class="int_type_no_border mgr_5 fl_r" v-if="status_code === 'P'">
								<!-- <a href="javascript:void(0);" type="button" class="gray_bt" style="background:yellow;" @click="wholeTicketPrint()">Reprint Whole Ticket</a>
								<a href="javascript:void(0);" type="button" class="gray_bt mgr_15" @click="printPickingTicket(false)">Reprint Picking Ticket</a> -->
								<span>
									Change to Packed
									<input type="text" ref="change_to_packed" v-model.trim="so_dn_packed" class="tbl_int sm_int mgr_10" placeholder="Enter SO No or Scan Barcode" @keypress.enter="makePackedOne()" @focus="$event.target.select()" />
								</span>
							</span>
							<span class="int_type_no_border mgr_5 fl_r" v-if="status_code === 'W'">
								<span>
									Change to Packing
									<input type="text" ref="change_to_packing" v-model.trim="so_dn_packing" class="tbl_int sm_int mgr_10" placeholder="Enter SO No or Scan Barcode" @keypress.enter="cancelPacking()" @focus="$event.target.select()" />
								</span>
							</span>
						</div>
					</td>
					<td style="width: 20%;">
						<div class="bottom_box" style="padding: 0px;">
							<table class="list_tbl">
								<colgroup>
									<col style="width: 34%;" />
									<col style="width: 33%;" />
									<col style="width: 33%;" />
								</colgroup>
								<thead>
									<tr>
										<th>Type</th>
										<th>Count</th>
										<th>Amount</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td class="al_center bg_none">6:00 PM</td>
										<td class="al_right bg_none">{{ packingInfoWithStatusWI.before_invoice_count || 0 | commaSeparated }}</td>
										<td class="al_right bg_none">{{ packingInfoWithStatusWI.before_invoice_amount || 0 | commaSeparated }}</td>
									</tr>
									<tr>
										<td class="al_center bg_none">After 6:00 PM</td>
										<td class="al_right bg_none">{{ packingInfoWithStatusWI.after_invoice_count || 0 | commaSeparated }}</td>
										<td class="al_right bg_none">{{ packingInfoWithStatusWI.after_invoice_amount || 0 | commaSeparated }}</td>
									</tr>
									<tr>
										<td class="al_center bg_none">Packed</td>
										<td class="al_right bg_none">{{ packingInfoWithStatusWI.packed_count || 0 | commaSeparated }}</td>
										<td class="al_right bg_none">{{ packingInfoWithStatusWI.packed_amount || 0 | commaSeparated }}</td>
									</tr>
								</tbody>
							</table>
						</div>
					</td>
				</tr>
			</table>
		</div>

		<div class="list_top_box">
			<div class="bottom_box" v-if="status_code === 'P' && sum_by_packing_status.length > 0" style="width: 50%;">
				<table class="list_tbl">
					<colgroup>
						<col style="width: 15%;" />
						<col style="width: 10%;" />
						<col style="width: 15%;" />
						<col style="width: 10%;" />
						<col style="width: 15%;" />
						<col style="width: 10%;" />
						<col style="width: 15%;" />
						<col style="width: 10%;" />
					</colgroup>
					<tbody>
						<tr>
							<template v-for="(status, index) in packing_status_list">
								<td class="al_center" :key="index + 'name'" :class="{ bg_none: selected_packing_status !== status }">
									<a href="javascript: void(0);" @click="searchByPackingStatus(status)">
										<b>{{ status }}</b>
									</a>
								</td>
								<td class="bg_none al_right" :key="index + 'count'">
									<span v-if="sum_by_packing_status.findIndex(el => el.packing_status === status) > -1">
										{{ sum_by_packing_status.find(el => el.packing_status === status).count | commaSeparated }}
									</span>
								</td>
							</template>
						</tr>
						<tr>
							<template v-for="(status, index) in packing_status_list">
								<td class="al_right bg_none" :key="index + 'amt'">
									<span v-if="sum_by_packing_status.findIndex(el => el.packing_status === status) > -1">
										<span>$ </span>
										{{ sum_by_packing_status.find(el => el.packing_status === status).amount | toCurrency }}
									</span>
								</td>
								<td class="al_right bg_none" :key="index + 'qty'">
									<span v-if="sum_by_packing_status.findIndex(el => el.packing_status === status) > -1">
										{{ sum_by_packing_status.find(el => el.packing_status === status).quantity | commaSeparated }}
									</span>
								</td>
							</template>
						</tr>
					</tbody>
				</table>
			</div>
		</div>

		<table v-if="status_code != 'Sample'" class="list_tbl" v-columns-resizable>
			<thead v-columns-resizable>
				<tr>
					<!-- <th width="5%">Status</th> -->
					<!-- <th v-if="status_code == 'A'" style="width:10px;"><input type="checkbox" @change="selectAll()" v-model="allSelected" /></th> -->
					<th v-if="status_code == 'A' || status_code == 'P'" style="width:10px;"><input type="checkbox" @change="selectAll()" v-model="allSelected" /></th>
					<th v-if="user.company_id == 'beautyplus' && (status_code == 'P' || status_code == 'W')" width="20px;">Add'l</th>
					<th style="width:90px;">
						<template v-if="status_code == 'A'"
							>&nbsp;
							<input type="checkbox" @change="selectWhole()" v-model="wholeSelected" />
							<span style="background-color:yellow;"> W&nbsp;&nbsp;</span>
							<!-- , D
							<input type="checkbox" @change="selectDesignated()" v-model="wholeDesignated" /> -->
						</template>
						<!-- Bill To -->
						<a href="javascript:;" @click="sort('bill_to_code')">Bill To{{ sortMark('bill_to_code') }}</a>
					</th>
					<th v-if="status_code == 'I' && user.company_id == 'hairplus'" style="width:90px;">
						<a href="javascript:;" @click="sort('ship_to_code')">Ship To{{ sortMark('ship_to_code') }}</a>
					</th>
					<th :style="user.company_id == 'newjigu' ? 'width:120px;' : 'width:105px;'">
						<a href="javascript:;" @click="sort('so_dn')">S/O No{{ sortMark('so_dn') }}</a>
					</th>
					<th v-if="profile.use_temp_flag == 'Y' && status_code == 'W'" style="width:45px;">
						State
					</th>
					<th style="width:95px;" v-if="status_code != 'I' || user.company_id != 'beautyplus'">
						<a href="javascript:;" @click="sort('so_date')">S/O Date{{ sortMark('so_date') }}</a>
					</th>
					<th style="width:150px;" v-if="status_code != 'W' && status_code != 'I'">
						<a href="javascript:;" @click="sort('crt_dt')">S/O Time{{ sortMark('crt_dt') }}</a>
					</th>
					<th style="width:150px;" v-if="status_code != 'O' && status_code != 'W' && status_code != 'H'">
						<a href="javascript:;" @click="sort('approval_dt')">Approval Time{{ sortMark('approval_dt') }}</a>
					</th>
					<!-- <th :style="status_code == 'P' ? 'width:300px;' : 'width:150px;'" v-if="status_code == 'P' || status_code == 'I'"> -->
					<th style="width:160px;" v-if="status_code == 'P' || status_code == 'I'">
						<a href="javascript:;" @click="sort('print_dt')">Print Time{{ sortMark('print_dt') }}</a>
					</th>
					<th style="width:150px;" v-if="status_code == 'W' || status_code == 'I'">
						<a href="javascript:;" @click="sort('packed_dt')">Packed Time{{ sortMark('packed_dt') }}</a>
					</th>
					<th style="width:95px;" v-if="status_code == 'I' && user.company_id != 'beautyplus'">
						<a href="javascript:;" @click="sort('invoice_date')">Invoice Date{{ sortMark('invoice_date') }}</a>
					</th>
					<th style="width:180px;" v-if="status_code == 'I'">
						<a href="javascript:;" @click="sort('invoice_dt')">Invoice Time{{ sortMark('invoice_dt') }}</a>
					</th>
					<th style="width:80px;" v-if="status_code == 'I' && user.company_id == 'beautyplus'">
						Invoice
					</th>
					<th style="width:80px;" v-if="status_code == 'I' && user.company_id == 'beautyplus'">
						<a href="javascript:;" @click="sort('label_printed')">UPS/FedEx{{ sortMark('label_printed') }}</a>
					</th>
					<th :style="user.company_id == 'hairplus' ? 'width:165px;' : 'width:140px;'" v-if="status_code == 'I'">
						<a href="javascript:;" @click="sort('invoice_dn')">Inv. No{{ sortMark('invoice_dn') }}</a>
					</th>
					<th style="width:95px;" v-if="status_code === 'P'">
						<a href="javascript:;" @click="sort('wh_packing_status')">Packing Status{{ sortMark('wh_packing_status') }}</a>
					</th>
					<!-- <th width="10%">Status Change Time</th> -->
					<!-- <th width="5%">Ship To Code</th>
					<th width="5%">Ship To Name</th>
					<th width="5%">Bill To Code</th>
					<th width="5%">Bill To Name</th>
					<th width="5%">Sales Group</th>
					<th width="3%">S/O Amt.</th>
					<th width="5%">S/O Entry</th> -->
					<th style="width:200px;">
						<a href="javascript:;" @click="sort('ship_to_code')">Ship To{{ sortMark('ship_to_code') }}</a>
					</th>
					<th style="width:100px;">
						<a href="javascript:;" @click="sort('sales_group_name')">Sales Group{{ sortMark('sales_group_name') }}</a>
					</th>
					<th style="width:100px;">
						<a href="javascript:;" @click="sort('payment_type')">Payment Type{{ sortMark('payment_type') }}</a>
					</th>
					<th :style="status_code == 'I' ? 'width:250px;' : 'width:100px'">
						<a href="javascript:;" @click="sort('delivery_type')">Delivery Type{{ sortMark('delivery_type') }}</a>
					</th>
					<th style="width:120px;">Ship Charge</th>
					<th style="width:10px;" v-if="status_code == 'I' && user.company_id != 'beautyplus'">Ship</th>
					<th style="width:50px;">Qty.</th>
					<template v-if="user.company_id == 'newjigu'">
						<th style="width:80px;">
							Req. Total
						</th>
						<th style="width:80px;">
							<span v-if="status_code == 'I'">Inv. Amt</span>
							<span v-else>Avail. Total</span>
						</th>
					</template>
					<template v-else>
						<th style="width:80px;">
							<a href="javascript:;" @click="sort('amount')">Amount{{ sortMark('amount') }}</a>
						</th>
					</template>
					<th style="width:100px;" v-if="status_code == 'I'">
						<a href="javascript:;" @click="sort('packed_user')">Packed User{{ sortMark('packed_user') }}</a>
					</th>
					<template v-if="status_code == 'P'">
						<th width="100px;">
							<template v-if="user.company_id != 'beautyplus' && (status_code == 'O' || status_code == 'H')">
								<a href="javascript:;" @click="sort('remark')">Remark{{ sortMark('remark') }}</a>
							</template>
							<template v-else>
								<a href="javascript:;" @click="sort('remark2')">Remark{{ sortMark('remark2') }}</a>
							</template>
						</th>
						<th width="40px;">W.B.</th>
						<th width="220px;">
							<a href="javascript:;" @click="sort('start_dt')">Start Time{{ sortMark('start_dt') }}</a>
						</th>
						<!-- <th width="2%;">HAIR</th>
						<th width="2%">WIG</th>
						<th width="2%">BRAID</th>
						<th width="2%">NEW</th>
						<th width="2%">PR</th>
						<th width="2%">BANNER</th>
						<th width="2%">MQ</th>
						<th width="2%">FLOOR</th>
						<th width="2%">BOX</th> -->
						<th v-for="location in locations" v-bind:key="location.code" style="width:50px;">{{ location.alt_code }}</th>
						<th width="220px;">
							<a href="javascript:;" @click="sort('end_dt')">End Time{{ sortMark('end_dt') }}</a>
						</th>
					</template>
					<template v-else>
						<th v-if="user.company_id == 'hairplus'">
							<template v-if="status_code == 'O' || status_code == 'H'">To Sales Remark</template>
							<template v-else-if="status_code == 'A' || status_code == 'P'">To Warehouse Staff</template>
							<template v-else-if="status_code == 'W' || status_code == 'PH' || status_code == 'I'">To Accounting</template>
						</th>
						<th v-else>Remark</th>
					</template>
					<th v-if="user.company_id == 'hairplus' && ['O', 'W'].includes(status_code)" width="220px;">
						Ship To / Address
					</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="invoice in invoices" v-bind:key="invoice.invoice_no">
					<!-- <td v-if="status_code == 'A'" class="al_center"><input type="checkbox" v-model="invoice.selected" /></td> -->
					<!-- <td v-if="status_code == 'A' || status_code == 'P'" class="al_center"><input v-if="status_code == 'A' || invoice.designated" type="checkbox" v-model="invoice.selected" /></td> -->
					<td v-if="status_code == 'A' || status_code == 'P'" class="al_center"><input v-if="status_code == 'A' || status_code == 'P'" type="checkbox" v-model="invoice.selected" /></td>
					<td v-if="user.company_id == 'beautyplus' && (status_code == 'P' || status_code == 'W')" width="20px;" class="al_center">
						<template v-if="invoice.main_invoice_no">
							<span :title="'Master SO : ' + invoice.main_so_dn">&#10004;</span>
						</template>
						<template v-else-if="invoice.has_additional_so">
							<span title="Has additional SO(s)">M</span>
						</template>
					</td>
					<!-- <td class="al_center">{{ invoice.status_code | saleStatusName }}</td> -->
					<td class="al_left" :style="invoice.whole_box_exists ? 'background:yellow;' : invoice.designated ? 'background:lightgreen;' : ''">
						<a href="javascript:;" @click="gotoPartner(invoice.bill_to_code)">{{ invoice.bill_to_code }}</a>
					</td>
					<td v-if="status_code == 'I' && user.company_id == 'hairplus'" class="al_left" :style="invoice.whole_box_exists ? 'background:yellow;' : invoice.designated ? 'background:lightgreen;' : ''">
						<a href="javascript:;" @click="gotoPartner(invoice.ship_to_code)">{{ invoice.ship_to_code }}</a>
					</td>
					<td class="al_left" :style="invoice.whole_box_exists ? 'background:yellow;' : invoice.designated ? 'background:lightgreen;' : ''">
						<a href="javascript:;" @click="selectInvoice(invoice)"
							><font :color="invoice.urgent_yn == 'Y' ? 'red' : 'black'">{{ invoice.so_dn }}</font></a
						>
						<a v-if="user.company_id == 'newjigu'" href="javascript:;" @click="viewItems(invoice)">(Item)</a>
						<a v-else-if="user.company_id == 'beautyplus' && ['P', 'W'].includes(status_code)" href="javascript:;" @click="gotoPacking(invoice)">(Packing Box)</a>
					</td>
					<td v-if="profile.use_temp_flag == 'Y' && status_code == 'W'">
						<font color="blue">{{ invoice.ship_to_state }}</font>
					</td>
					<td class="al_left" v-if="status_code != 'I' || user.company_id != 'beautyplus'" :style="invoice.designated ? 'background:lightgreen;' : ''">{{ invoice.so_date }}</td>
					<td class="al_left truncate" v-if="status_code != 'W' && status_code != 'I'" :style="invoice.designated ? 'background:lightgreen;' : ''" :title="invoice.crt_dt | moment('MM-DD-YYYY HH:mm:ss')">
						{{ invoice.crt_dt | moment('MM-DD-YYYY HH:mm:ss') }}
					</td>
					<td class="al_left truncate" v-if="status_code != 'O' && status_code != 'W' && status_code != 'H'" :style="invoice.designated ? 'background:lightgreen;' : ''" :title="invoice.approval_dt | moment('MM-DD-YYYY HH:mm:ss')">
						{{ invoice.approval_dt | moment('MM-DD-YYYY HH:mm:ss') }}
					</td>
					<td class="al_left truncate" v-if="status_code == 'P' || status_code == 'I'" :style="invoice.designated ? 'background:lightgreen;' : ''" :title="invoice.pt_last_print_dt | moment('MM-DD-YYYY HH:mm:ss')">
						<font :color="invoice.urgent_yn == 'Y' ? 'red' : 'black'">{{ invoice.pt_last_print_dt | moment('MM-DD-YYYY HH:mm:ss') }}</font>
					</td>
					<td class="al_left truncate" v-if="status_code == 'W' || status_code == 'I'" :style="invoice.designated ? 'background:lightgreen;' : ''" :title="invoice.packed_dt | moment('MM-DD-YYYY HH:mm:ss')">
						{{ invoice.packed_dt | moment('MM-DD-YYYY HH:mm:ss') }}
					</td>
					<td class="al_left truncate" v-if="status_code == 'I' && user.company_id != 'beautyplus'" :style="invoice.designated ? 'background:lightgreen;' : ''" :title="invoice.invoice_date">{{ invoice.invoice_date }}</td>
					<td class="al_left truncate" v-if="status_code == 'I'" :style="invoice.designated ? 'background:lightgreen;' : ''" :title="invoice.invoice_dt | moment('MM-DD-YYYY HH:mm:ss')">
						{{ invoice.invoice_dt | moment('MM-DD-YYYY HH:mm:ss') }}
					</td>
					<td v-if="status_code == 'I' && user.company_id == 'beautyplus'">
						<span v-if="profile.use_temp_flag == 'Y' && user.temp_flag && invoice.invoice_print_user" :style="{ color: invoice.invoice_print_warehouse ? 'orange' : 'blue', fontWeight: 'bold' }">PRINTED</span>
					</td>
					<td v-if="status_code == 'I' && user.company_id == 'beautyplus'">
						<span v-if="profile.use_temp_flag == 'Y' && user.temp_flag && invoice.label_printed" :style="{ color: invoice.label_print_warehouse ? 'orange' : 'green', fontWeight: 'bold' }">PRINTED</span>
					</td>
					<td class="al_left truncate" v-if="status_code == 'I'" :style="invoice.designated ? 'background:lightgreen;' : ''">
						<!-- <span v-if="profile.use_temp_flag == 'Y' && user.temp_flag && (invoice.invoice_print_user == user.user_id || invoice.invoice_reprint_user == user.user_id)" style="color:blue;font-weight:bold;">INV. PRINTED</span> -->
						<a href="javascript:;" @click="selectInvoice(invoice, 'invoice')">{{ invoice.invoice_dn }}</a>
						<a v-if="user.company_id == 'newjigu'" href="javascript:;" @click="viewItems(invoice)">(Item)</a>
					</td>
					<td class="al_left truncate" v-if="status_code === 'P'" :style="invoice.designated ? 'background:lightgreen;' : ''">
						{{ invoice.packing_status }}
					</td>

					<!-- <td class="al_left truncate">{{ invoice.status_dt | moment('MM-DD-YYYY HH:mm:ss') }}</td> -->
					<!-- <td class="al_left">
						<a href="javascript:;" @click="gotoPartner(invoice.ship_to_code)">{{ invoice.ship_to_code }}</a>
					</td>
					<td class="al_left truncate">
						<a href="javascript:;" @click="gotoPartner(invoice.ship_to_code)">{{ invoice.ship_to_name }}</a>
					</td>

					<td class="al_left truncate">
						<a href="javascript:;" @click="gotoPartner(invoice.bill_to_code)">{{ invoice.bill_to_name }}</a>
					</td>
					<td class="al_left">{{ invoice.sales_group_name }}</td>
					<td class="al_right" v-if="invoice.status_code == 'I'">{{ invoice.total_shipped_amount | toCurrency }}</td>
					<td class="al_right" v-else>{{ invoice.total_amount | toCurrency }}</td>
					<td class="al_left truncate">{{ invoice.crt_name }}</td> -->
					<td class="al_left truncate" :style="invoice.designated ? 'background:lightgreen;' : ''">
						<a href="javascript:;" @click="gotoPartner(invoice.ship_to_code)">{{ invoice.ship_to_name }}</a>
					</td>
					<td class="al_left" :title="invoice.salesman_name ? 'Salesman : ' + invoice.salesman_name : ''">{{ invoice.sales_group_name }}</td>
					<td class="al_left" :style="{ color: status_code == 'W' && user.company_id == 'beautyplus' && invoice.payment_term_code === 'VC' ? 'blue' : '' }">{{ invoice.payment_term_name }}</td>
					<td class="al_left" :style="{ color: status_code == 'W' && user.company_id == 'beautyplus' && invoice.delivery_type_code === 'T15' ? 'red' : '' }">
						{{ invoice.delivery_type_name }}

						<a
							v-if="status_code == 'I' && invoice.shipment_info_exists && invoice.delivery_type_name.toUpperCase().indexOf('UPS') >= 0"
							:href="'https://ups.com/track?loc=null&tracknum=' + invoice.track_no + '&requester=WT/trackdetails'"
							target="_blank"
							>- <font color="blue">{{ invoice.track_no }}</font></a
						>
						<a
							v-if="status_code == 'I' && invoice.shipment_info_exists && invoice.delivery_type_name.toUpperCase().indexOf('FEDEX') >= 0"
							:href="'https://www.fedex.com/fedextrack/?trknbr=' + invoice.track_no + '&requester=WT/trackdetails'"
							target="_blank"
							>- <font color="blue">{{ invoice.track_no }}</font></a
						>

						<!-- <a href="javascript:;" v-if="status_code == 'I' && invoice.shipment_info_exists"
							>- <font color="blue">{{ invoice.track_no }}</font></a
						> -->
					</td>
					<td class="al_left">{{ invoice.ship_charge_name }}</td>
					<td class="al_center" v-if="status_code == 'I' && user.company_id != 'beautyplus'">
						<span v-if="invoice.shipped"><font color="red">&#10004;</font></span>
					</td>
					<td class="al_right">
						<span v-if="invoice.status_code == 'I' || invoice.status_code == 'W' || invoice.status_code == 'PH'">
							{{ invoice.total_shipped_quantity | commaSeparated }}
						</span>
						<span v-else>
							{{ invoice.total_quantity | commaSeparated }}
						</span>
						<!-- {{ invoice.status_code == 'W' || invoice.status_code == 'I' ? invoice.total_shipped_quantity : invoice.total_quantity | commaSeparated }} -->
					</td>
					<template v-if="user.company_id == 'newjigu'">
						<td class="al_right">{{ invoice.total_request_amount | toCurrency }}</td>
						<td v-if="invoice.status_code == 'I'" class="al_right">
							{{ invoice.invoice_amount | toCurrency }}
						</td>
						<td v-else class="al_right">
							{{ invoice.total_valid_amount | toCurrency }}
						</td>
					</template>
					<template v-else>
						<td v-if="invoice.status_code == 'I'" class="al_right">{{ invoice.invoice_amount | toCurrency }}</td>
						<td v-else class="al_right">{{ invoice.status_code == 'W' || invoice.status_code == 'PH' ? invoice.total_shipped_amount : invoice.total_amount | toCurrency }}</td>
					</template>
					<td class="al_left truncate" v-if="status_code == 'I'">
						<span :title="invoice.packed_user_name">{{ invoice.packed_user_name }}</span>
					</td>

					<template v-if="user.company_id != 'beautyplus' && (status_code == 'O' || status_code == 'H')">
						<template v-if="user.company_id == 'hairplus'">
							<td class="al_left truncate" :title="invoice.general_remark">
								{{ invoice.general_remark }}
							</td>
						</template>
						<template v-else>
							<td class="al_left truncate" :title="invoice.remark">
								{{ invoice.remark }}
							</td>
						</template>
					</template>
					<template v-else>
						<template v-if="user.company_id == 'newjigu'">
							<td class="al_left truncate" :title="invoice.remark + ' / ' + invoice.remark2">{{ invoice.remark }} / {{ invoice.remark2 }}</td>
						</template>
						<template v-else-if="user.company_id == 'hairplus'">
							<template v-if="status_code == 'A' || status_code == 'P'">
								<td class="al_left truncate" :title="invoice.remark2">
									{{ invoice.remark2 }}
								</td>
							</template>
							<template v-else-if="status_code == 'PH' || status_code == 'W' || status_code == 'I'">
								<td class="al_left truncate" :title="invoice.remark">
									{{ invoice.remark }}
								</td>
							</template>
							<template v-else>
								<td></td>
							</template>
							<!-- {{ invoice.general_remark }} -->
						</template>
						<template v-else>
							<td class="al_left truncate" :title="user.company_id == 'beautyplus' && invoice.remark && (status_code == 'PH' || status_code == 'W' || status_code == 'I') ? invoice.remark2 + ' / ' + invoice.remark : invoice.remark2">
								{{ invoice.remark2 }} <span v-if="user.company_id == 'beautyplus' && invoice.remark && (status_code == 'PH' || status_code == 'W' || status_code == 'I')"> / {{ invoice.remark }} </span>
							</td>
						</template>
					</template>

					<template v-if="status_code == 'P'">
						<td class="al_right" :style="'background-color:' + getBackColorWB(invoice) + ';'">
							<!-- <span v-if="invoice.whole_box_count_to_pack > 0">
								<font :color="invoice.whole_box_count_packed >= invoice.whole_box_count_to_pack ? 'red' : 'black'"> {{ invoice.whole_box_count_packed }} / {{ invoice.whole_box_count_to_pack }} </font>
							</span> -->
						</td>
						<td class="al_left truncate">
							{{ invoice.start_dt_str }}<span v-if="invoice.start_dt_str" :title="invoice.start_picker_name"> ({{ invoice.start_picker_name }})</span>
						</td>
						<td v-for="location in locations" v-bind:key="location.code" class="al_center" :style="'background-color:' + getBackColor(invoice, location.code) + ';'">
							<!-- <div style="width:52px;height:46px;white-space:wrap;overflow:hidden;" :title="invoice.pickup_status_map ? getTime(invoice.pickup_status_map.get(location.code)) : null"> -->
							<!-- <div :title="invoice.pickup_status_map ? getTime(invoice.pickup_status_map.get(location.code)) : null"> -->
							<!-- <b>{{ location.code }}</b> -->
							<!-- <b>{{ getPickupStatus(invoice, location.code) }} </b> -->
							<!-- <b>{{ invoice.pickup_status_map ? (invoice.pickup_status_map.get(location.code) == 'complete' ? null : invoice.pickup_status_map.get(location.code)) : null }}</b> -->
							<!-- <b><font :color="getBackColor(invoice, location.code) == 'red' ? 'yellow' : 'black'">{{ invoice.pickup_status_map ? getTime(invoice.pickup_status_map.get(location.code)) : null }}</font></b> -->
							<!-- </div> -->
						</td>
						<td class="al_left truncate">
							{{ invoice.end_dt_str }}<span v-if="invoice.end_dt_str" :title="invoice.end_picker_name"> ({{ invoice.end_picker_name }})</span>
						</td>
						<!-- <td class="al_center" style="background-color:yellow;">
							<div style="width:50px;">
								<b>{{ locations[0].code }}</b>
							</div>
						</td>
						<td class="al_center">
							<div style="width:50px;"><b>12:11:22</b></div>
						</td>
						<td class="al_center">
							<div style="width:50px;"><b>12:11:22</b></div>
						</td>
						<td class="al_center">
							<div style="width:50px;"><b>12:11:22</b></div>
						</td>
						<td class="al_center">
							<div style="width:50px;"><b>12:11:22</b></div>
						</td>
						<td class="al_center">
							<div style="width:50px;"><b>12:11:22</b></div>
						</td>
						<td class="al_center" style="background-color:white;">
							<div style="width:50px;"></div>
						</td>
						<td class="al_center">
							<div style="width:50px;"><b>12:11:22</b></div>
						</td>
						<td class="al_left" style="background-color:red;">
							<div style="width:50px;"></div>
						</td> -->
					</template>
					<td v-if="user.company_id == 'hairplus' && ['O', 'W'].includes(status_code)">
						<!-- {{ invoice.ship_to_address_detail }}, {{ invoice.partner_address_detail }} -->
						<span v-if="invoice.bill_to_code != invoice.ship_to_code" :title="invoice.ship_to_name">{{ invoice.ship_to_code }}</span>
						<span v-else-if="invoice.ship_to_address_detail != invoice.partner_address_detail" :title="invoice.ship_to_address_detail">{{ invoice.ship_to_address_detail }}</span>
					</td>
				</tr>
			</tbody>
		</table>
		<table v-else class="list_tbl" v-columns-resizable>
			<thead>
				<tr>
					<th width="6%">Sample No</th>
					<th width="8%">Status</th>
					<th width="6%">Entry Date</th>
					<th width="8%">Entry User</th>
					<th width="6%">Request Date</th>
					<th width="6%">Ready Date</th>
					<th width="6%">Pick Up Date</th>
					<th width="8%">Pick Up User</th>
					<!-- <th width="6%">Return Date</th> -->
					<th width="10%">Print Date Time</th>
					<th width="10%">Sales Group</th>
					<th width="4%">Req. Qty.</th>
					<th width="4%">Pick Qty.</th>
					<th>Description</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="sample in samples" v-bind:key="sample.sample_no">
					<td class="al_left">
						<a href="javascript:;" @click="selectSample(sample)">{{ sample.sample_dn }}</a>
					</td>
					<td class="al_center">{{ sample.status_code | sampleStatusName }}</td>
					<td class="al_left">{{ sample.entry_date }}</td>
					<td class="al_left">{{ sample.crt_name }}</td>
					<td class="al_left">{{ sample.request_date }}</td>
					<td class="al_left">{{ sample.ready_date }}</td>
					<td class="al_left">{{ sample.pickup_date }}</td>
					<td class="al_left">{{ sample.pickup_name }}</td>
					<!-- <td class="al_left">{{ sample.return_date }}</td> -->
					<td class="al_left">{{ sample.print_dt | moment('MM-DD-YYYY HH:mm:ss') }}</td>
					<td class="al_left">{{ sample.sales_group_name }}</td>
					<td class="al_right">{{ sample.total_request_quantity | commaSeparated }}</td>
					<td class="al_right">{{ sample.total_pick_quantity | commaSeparated }}</td>
					<td class="al_left">{{ sample.description }}</td>
				</tr>
			</tbody>
		</table>

		<!-- <div style="text-align:right;padding-right:10px;">Total Count : {{ list_count | commaSeparated }}</div> -->

		<!-- <div style="text-align:left;padding-left:10px;">
			<span style="color:red;font-size:large;font-weight:bold"
				>Open : {{ open_count | commaSeparated }}, Approved : {{ approved_count | commaSeparated }}, Packing : {{ packing_count | commaSeparated }}, Packed :
				{{ packed_count | commaSeparated }}</span
			>
		</div> -->
		<template v-if="status_code === 'O'">
			<table v-show="false" id="open_list">
				<tr>
					<th>Number</th>
					<th>Bill To</th>
					<th>S/O No</th>
					<th>S/O Date</th>
					<th>Ship To</th>
					<th>Sales Group</th>
					<th>Qty</th>
					<th>Amount</th>
				</tr>
				<tr v-for="(invoice, index) in dataForExcel.invoiceList" v-bind:key="invoice.invoice_no">
					<td>{{ index + 1 }}</td>
					<td>{{ invoice.bill_to_code }}</td>
					<td>{{ invoice.so_dn }}</td>
					<td>{{ invoice.so_date }}</td>
					<td>{{ invoice.ship_to_name }}</td>
					<td>{{ invoice.sales_group_name }}</td>
					<td>{{ invoice.total_quantity | commaSeparated }}</td>
					<td>{{ invoice.total_amount | toCurrency }}</td>
				</tr>
				<tr v-if="dataForExcel.invoicesSum">
					<td colspan="6">Total</td>
					<td>{{ dataForExcel.invoicesSum.total_quantity_sum | commaSeparated }}</td>
					<td>{{ dataForExcel.invoicesSum.total_amount_sum | toCurrency }}</td>
				</tr>
			</table>
		</template>
		<template v-if="status_code === 'W'">
			<table v-show="false" id="packed_list">
				<tr>
					<th>Number</th>
					<th>Bill To</th>
					<th>S/O No</th>
					<th>S/O Date</th>
					<th>Packed Time</th>
					<th>Ship To</th>
					<th>Sales Group</th>
					<th>Payment Type</th>
					<th>Delivery Type</th>
					<th>Ship Charge</th>
					<th>Qty</th>
					<th>Amount</th>
					<th>Remark</th>
				</tr>
				<tr v-for="(invoice, index) in dataForExcel.invoiceList" v-bind:key="invoice.invoice_no">
					<td>{{ index + 1 }}</td>
					<td>{{ invoice.bill_to_code }}</td>
					<td>{{ invoice.so_dn }}</td>
					<td>{{ invoice.so_date }}</td>
					<td>{{ invoice.packed_dt | moment('MM-DD-YYYY HH:mm:ss') }}</td>
					<td>{{ invoice.ship_to_name }}</td>
					<td>{{ invoice.sales_group_name }}</td>
					<td>{{ invoice.payment_term_name }}</td>
					<td>{{ invoice.delivery_type_name }}</td>
					<td>{{ invoice.ship_charge_name }}</td>
					<td>{{ invoice.total_quantity | commaSeparated }}</td>
					<td>{{ invoice.total_amount | toCurrency }}</td>
					<td>{{ invoice.remark2 }}</td>
				</tr>
				<tr v-if="dataForExcel.invoicesSum">
					<td colspan="10">Total</td>
					<td>{{ dataForExcel.invoicesSum.total_quantity_sum | commaSeparated }}</td>
					<td>{{ dataForExcel.invoicesSum.total_amount_sum | toCurrency }}</td>
					<td></td>
				</tr>
			</table>
		</template>

		<Paging ref="paging" v-on:gotoPage="gotoPage"></Paging>

		<!-- <div class="view_bottom_bt">
			<a v-if="status_code == 'P'" href="javascript:;" type="button" :class="selectedInvoices.length == 0 ? 'disable_bt' : 'search_bt'" @click="completePacking()"
				>Complete Packing</a
			>
		</div> -->

		<div v-if="status_code != 'Sample'" class="bottom_bt_box">
			<ul>
				<li class="mgr_15">
					<PageSizeSelect v-model="page_size" @input="search()" />
				</li>
				<!-- <li><router-link :to="{ name: 'soDetail', params: { mode: 'add' }, query: { backUri: this.$route.fullPath } }">Add</router-link></li> -->
				<li v-if="status_code === 'O' && excelExportable('/sales/so_main')"><a href="javascript:void(0);" type="button" class="gray_bt" @click="excel()">Excel</a></li>
				<li v-if="status_code === 'W' && excelExportable('/sales/boxing')"><a href="javascript:void(0);" type="button" class="gray_bt" @click="excelPacked()">Excel</a></li>
				<li v-if="status_code === 'I' && excelExportable('/sales/invoice_main')"><a href="javascript:void(0);" type="button" class="gray_bt" @click="excelInvoice()">Excel</a></li>
				<li v-if="status_code === 'A'"><a href="javascript:void(0);" type="button" class="gray_bt" style="background:yellow;" @click="wholeTicketPrint()">Whole Ticket</a></li>
				<li v-if="status_code === 'A'"><a href="javascript:void(0);" type="button" class="gray_bt" @click="printPickingTicket(true)">Picking Ticket</a></li>
				<li v-if="status_code === 'A'"><a href="javascript:void(0);" type="button" class="gray_bt" @click="packingBox(true)">Packing Box</a></li>

				<template v-if="status_code === 'P'">
					<li><a href="javascript:void(0);" type="button" class="gray_bt" style="background:yellow;" @click="wholeTicketPrint()">Reprint Whole Ticket</a></li>
					<li><a href="javascript:void(0);" type="button" class="gray_bt mgr_15" @click="printPickingTicket(false)">Reprint Picking Ticket</a></li>
					<li>Change to Packed <input type="text" v-model.trim="so_dn_packed" class="tbl_int sm_int mgr_10" placeholder="Enter SO No or Scan Barcode" @keypress.enter="makePackedOne()" @focus="$event.target.select()" /></li>
				</template>
				<template v-if="status_code === 'W'">
					<li style="margin-left:10px;">
						Change to Packing
						<input type="text" v-model.trim="so_dn_packing" class="tbl_int sm_int mgr_10" placeholder="Enter SO No or Scan Barcode" @keypress.enter="cancelPacking()" @focus="$event.target.select()" />
					</li>
				</template>
				<!-- <li v-if="status_code === 'P'"><a href="javascript:void(0);" type="button" class="gray_bt" @click="makePacked()">Change to 'Packed' status</a></li> -->
			</ul>
		</div>

		<Modal @close="labelModal" v-if="labelShowModal" :draggable="false">
			<template slot="title">Unit Box Label</template>
			<template slot="body">
				<table class="list_tbl">
					<thead>
						<tr>
							<th>Label</th>
							<th>Count</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="obj in locationCountList" v-bind:key="obj.name">
							<td class="al_center">{{ obj.name }}</td>
							<td class="al_right">
								<currency-input type="text" class="tbl_int full_int al_right" v-model.trim="obj.count" :precision="0" @focus="$event.target.select()" v-on:keyup.enter="unitTicketPrint()" />
							</td>
						</tr>
					</tbody>
				</table>
				<div class="popup_bottom">
					<a href="javascript:void(0);" @click="unitTicketPrint()" class="search_bt">Print</a>
					<a href="javascript:void(0);" @click="labelModal()" class="gray_bt">Close</a>
				</div>
			</template>
		</Modal>

		<Modal @close="closeModal" v-if="showModal && modalName == 'ViewItems'" :draggable="true">
			<template slot="title">
				<template v-if="selected_invoice.status_code == 'I'"> Invoice No : {{ selected_invoice.invoice_dn }} Item(s) </template>
				<template v-else> SO No : {{ selected_invoice.so_dn }} Item(s) </template>
			</template>
			<template slot="body">
				<SoItemPopup :invoice="selected_invoice" v-on:close="closeModal()" />
			</template>
		</Modal>
	</div>
</template>

<script>
import { inputSelectOnClick } from '@/utils/etc.js';
import _ from 'lodash';
import { apiCancelPacking, apiCompletePacking, apiSoIndex, apiPickingPrintDataList, apiPrintPickingTicketBatch, apiSelectInvoice, apiSelectInvoiceList, apiCheckSOWithNotApprovedStatus } from '@/api/sales/invoice.js';
import { apiPackingInfoWithStatusWI } from '@/api/report/report.js';
import Paging from '@/components/common/Paging';
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import CodeSelect from '@/components/common/CodeSelect';
import PageSizeSelect from '@/components/common/PageSizeSelect';
import PartnerSelect from '@/components/common/PartnerSelect';
//import ItemClassSelect from '@/components/common/ItemClassSelect';
import ItemClassSelectMultiS from '@/components/common/ItemClassSelectMultiS';
import SoSelect from '@/components/common/SoSelect';
import SoItemPopup from '@/components/common/SoItemPopup';
import Modal from '@/components/common/Modal';
import { daysAgo, today } from '@/utils/date.js';
import { apiGetBase64ReportTemplate, companyMrtUrl, exportDataExcel, getMrtFile, objectToFormData, PrintType, Report } from '@/api/util';
import { defaultDataType } from 'export-xlsx';
import moment from 'moment/moment';
export default {
	props: ['headers'],
	data: function() {
		return {
			uri: null,
			backUri: '/',
			paging_yn: 'Y',
			page_size: 25,
			page_no: 1,
			list_count: 0,

			status_code: 'O',
			trans_date_from: daysAgo(7),
			trans_date_to: today(),
			sales_group_code: null,
			customer_code: null,
			//itemClass: null,
			itemClasses: [],
			delivery_type_code: null,
			country_type: null,
			designation_type: null,

			state: '',
			states: [],

			salesGroups: [],
			saleStatusCodes: [],
			locations: [],
			deliveryTypes: [],

			invoices: [],
			//temp_invoices: [],
			samples: [],
			dataForExcel: [],

			allSelected: false,
			wholeSelected: false,
			wholeDesignated: false,

			modalName: '',
			showModal: false,
			labelShowModal: false,

			open_count: 0,
			open_sum: 0,
			hold_count: 0,
			hold_sum: 0,
			approved_count: 0,
			approved_sum: 0,
			packing_count: 0,
			packing_sum: 0,
			packed_count: 0,
			packed_sum: 0,
			invoice_count: 0,
			invoice_sum: 0,
			packed_hold_count: 0,
			packed_hold_sum: 0,
			sample_count: 0,

			interval: null,

			so_dn: null,
			so_dn_unit_ticket: null,
			invoiceForUnitTicket: null,

			so_dn_packed: null,
			so_dn_packing: null,

			auto_refresh: false,
			wh_not_printed: false,

			sort_key: null,
			sort_direction: 'ASC',

			last_search_time: null,

			over_1_minute: false,

			packingInfoWithStatusWI: {},
			sum_by_packing_status: [],
			packing_status_list: ['PRINTED', 'PICKING', 'READY TO PACK', 'PACKING'],
			selected_packing_status: null,

			selected_invoice: {},

			temp_flag: null,
		};
	},
	computed: {
		// 	orderedInvoices: function() {
		// 		var skey = null;
		// 		var sdirection = null;
		// 		if (this.sort_key == 'print_dt') {
		// 			skey = ['urgent_yn', 'pt_last_print_dt_str'];
		// 			sdirection = ['desc', this.sort_direction];
		// 		}
		// 		console.log('sorting');
		// 		return _.orderBy(this.invoices, skey, sdirection);
		// 	},
		user: function() {
			return this.$session.get('user');
		},
		profile: function() {
			return this.$session.get('profile');
		},
		locationCountList: function() {
			let locationCountList = [];

			this.locations.forEach(value => {
				let obj = { name: value.name, count: 0 };
				locationCountList.push(obj);
			});
			return locationCountList;
		},
		filteredStates: function() {
			if (this.country_type == 'US') return this.states.filter(s => s.country == 'US' || s.country == 'USA');
			else if (this.country_type == 'NON_US') return this.states.filter(s => s.country != 'US' && s.country != 'USA');
			else return this.states;
		},
		// elapsedSearchSeconds: function() {
		// 	if (this.last_search_time) return (new Date() - this.last_search_time) / 1000;
		// 	else return 0;
		// },
	},
	components: {
		CustomDatePicker,
		CodeSelect,
		Paging,
		PartnerSelect,
		//ItemClassSelect,
		ItemClassSelectMultiS,
		PageSizeSelect,
		SoSelect,
		SoItemPopup,
		Modal,
	},
	methods: {
		viewItems(invoice) {
			this.selected_invoice = invoice;
			this.modalName = 'ViewItems';
			this.showModal = true;
		},
		excelExportable(path) {
			var menus = this.$session.get('menus');
			for (var i = 0; i < menus.length; i++) {
				if (menus[i].path == path && menus[i].view_yn == 'Y') return true;
			}
			return false;

			// console.log(menus);
			// return true;
		},
		selectSample(sample) {
			let routeData = this.$router.resolve({ name: 'sampleDetail', params: { mode: 'detail' }, query: { backUri: this.uri, sample_no: sample.sample_no } });
			window.open(routeData.href, 'herp_sample');
		},
		async selectInvoiceForPacked() {
			const { data } = await apiSelectInvoice({
				so_dn: this.so_dn_packed,
				for_boxing: true,
			});
			//console.log(data);

			data.invoice.boxList = data.boxList;

			return data.invoice;
		},
		async selectInvoiceForPacking() {
			const { data } = await apiSelectInvoice({
				so_dn: this.so_dn_packing,
			});

			return data.invoice;
		},
		async makePackedOne() {
			var invoiceToPacked = await this.selectInvoiceForPacked();

			if (!invoiceToPacked) {
				this.$toast.error(this.so_dn_packed + ': Not found');
				this.so_dn_packed = null;
				return;
			}

			if (invoiceToPacked.invoice_type == 'R') {
				this.$toast.error(this.so_dn_packed + ': Return SO cannot not be changed to Packed.');
				this.so_dn_packed = null;
				return;
			}

			if (invoiceToPacked.status_code == 'I') {
				this.$toast.error(this.so_dn_packed + ': Invoiced SO cannot not be changed to Packed');
				this.so_dn_packed = null;
				return;
			} else if (invoiceToPacked.status_code == 'V' || invoiceToPacked.status_code == 'VI') {
				this.$toast.error('Void Sales Order or Invoice');
				this.so_dn_packed = null;
				return;
			} else if (invoiceToPacked.status_code == 'W') {
				this.$toast.error(this.so_dn_packed + ': This SO was already packed');
				this.so_dn_packed = null;
				return;
			} else if (invoiceToPacked.status_code == 'PH' || invoiceToPacked.status_code == 'H') {
				this.$toast.error(this.so_dn_packed + ': Cancel the hold first');
				this.so_dn_packed = null;
				return;
			}

			if (this.user.company_id == 'beautyplus') {
				if (invoiceToPacked.boxList.filter(b => !(b.weight > 0)).length > 0) {
					this.$toast.error('Box with no weight exists');
					return;
				}
			}

			invoiceToPacked.apply_shipped_quantity = true; //shipped quantitym, amount 반영해야함

			const { data } = await apiCompletePacking(invoiceToPacked);

			if (data.result) {
				this.$toast.success(this.so_dn_packed + ': Made Packed Successfully');
				this.so_dn_packed = null;
				this.search(true);
				// this.search();
			} else {
				this.$toast.error(this.so_dn_packed + ': ' + data.msg);
				this.so_dn_packed = null;
			}
			//var invoiceToMakePacked = await this.selectInvoiceForUnitTicket();
		},
		async cancelPacking() {
			var invoiceToPacking = await this.selectInvoiceForPacking();

			if (!invoiceToPacking) {
				this.$toast.error(this.so_dn_packing + ': Not found');
				this.so_dn_packing = null;
				return;
			}

			if (invoiceToPacking.invoice_type == 'R') {
				this.$toast.error(this.so_dn_packing + ': Return SO cannot not be changed to Packing');
				this.so_dn_packing = null;
				return;
			}

			if (invoiceToPacking.status_code == 'I') {
				this.$toast.error(this.so_dn_packing + ': Invoiced SO cannot not be changed to Packed');
				this.so_dn_packing = null;
				return;
			} else if (invoiceToPacking.status_code == 'V' || invoiceToPacking.status_code == 'VI') {
				this.$toast.error('Void Sales Order or Invoice');
				this.so_dn_packing = null;
				return;
			} else if (invoiceToPacking.status_code == 'P') {
				this.$toast.error(this.so_dn_packing + ': This SO was already packing');
				this.so_dn_packing = null;
				return;
			} else if (invoiceToPacking.status_code == 'PH' || invoiceToPacking.status_code == 'H') {
				this.$toast.error(this.so_dn_packing + ': Cancel the hold first');
				this.so_dn_packed = null;
				return;
			}

			const { data } = await apiCancelPacking(invoiceToPacking);

			if (data.result) {
				this.$toast.success(this.so_dn_packing + ': Made Packing Successfully');
				this.so_dn_packing = null;
				this.search(true);
				// this.search();
			} else {
				this.$toast.error(this.so_dn_packing + ': ' + data.msg);
				this.so_dn_packing = null;
			}
			//var invoiceToMakePacked = await this.selectInvoiceForUnitTicket();
		},
		async selectInvoiceForUnitTicket() {
			const { data } = await apiSelectInvoice({
				so_dn: this.so_dn_unit_ticket,
			});

			return data.invoice;
		},
		async unitTicketPrint() {
			const list = [];
			this.locationCountList.forEach(value => {
				for (let i = 0; i < value.count; i++) {
					list.push(value.name);
				}
			});

			const { data } = await apiPickingPrintDataList(objectToFormData({ invoiceNos: this.invoiceForUnitTicket.invoice_no }));
			const invoice = data.data[0];
			invoice.unitLabelList = list;
			const reportTemplate = await apiGetBase64ReportTemplate('UnitBoxTicket', companyMrtUrl('UnitBoxTicket'));
			const report = new Report(reportTemplate, invoice, 'UnitBoxTicket', PrintType.Normal);
			this.labelModal();
			this.$store.commit('setReport', report);
			this.$toast.success('Unit Box Ticket Printed Successfully');
			this.so_dn_unit_ticket = null;
		},
		async unitTicketModal() {
			this.invoiceForUnitTicket = await this.selectInvoiceForUnitTicket();
			if (!this.invoiceForUnitTicket) {
				this.$toast.error('Not found');
				return false;
			} else {
				this.locationCountList.forEach(l => {
					l.count = 0;
				});
				this.labelShowModal = true;
			}
		},
		labelModal() {
			this.labelShowModal = false;
		},
		async getExcelData() {
			var param = {
				for_pickup: true,

				status_code: this.status_code,
				trans_date_from: this.trans_date_from,
				trans_date_to: this.trans_date_to,
				sales_group_code: this.sales_group_code,
				customer_code: this.customer_code,
				//class_code: this.itemClass,
				item_classes: this.itemClasses,
				delivery_type_code: this.delivery_type_code,

				sort_key: this.sort_key,
				sort_direction: this.sort_direction,

				so_dn: this.so_dn,
			};

			if (this.temp_flag != null) param.temp_flag = this.temp_flag;
			if (this.wh_not_printed && this.status_code == 'I') param.wh_not_printed = true;

			//if ((this.status_code == 'O' || this.status_code == 'A' || this.status_code == 'P') && this.designation_type != null) param.designation_type = this.designation_type;
			if (this.designation_type != null) param.designation_type = this.designation_type;

			const { data } = await apiSelectInvoiceList(param);
			return data;
		},
		async excel() {
			//this.dataForExcel = data;
			this.dataForExcel = await this.getExcelData();
			this.dataForExcel.invoiceList.forEach((value, i) => (value.number = i + 1));

			let header = [
				{ key: 'number', name: 'Number', width: 10, dataType: defaultDataType.currency },
				{ key: 'bill_to_code', name: 'Bill To', width: 10 },
				{ key: 'so_dn', name: 'S/O No', width: 25 },
				{ key: 'so_date', name: 'S/O Date', width: 25 },
				{ key: 'ship_to_name', name: 'Ship To', width: 25 },
				{ key: 'sales_group_name', name: 'Sales Group', width: 20 },
				{ key: 'total_quantity', name: 'Qty', width: 15, dataType: defaultDataType.currency },
				{ key: 'total_amount', name: 'Amount', width: 15, dataType: defaultDataType.number },
			];
			if (this.user.company_id == 'beautyplus' || this.user.company_id == 'hairplus') {
				let idx = header.findIndex(h => h.key === 'total_quantity');
				header.splice(idx, 0, { key: 'salesman_name', name: 'Salesman', width: 20 });
			}
			exportDataExcel(this.dataForExcel.invoiceList, header, 'OpenSO_' + this.trans_date_from + '_' + this.trans_date_to);
			// this.$nextTick(function() {
			// 	var elt = document.getElementById('open_list');
			// 	var wb = XLSX.utils.table_to_book(elt, { sheet: 'Open Sales Order', raw: true });
			// 	return XLSX.writeFile(wb, 'OpenSO_' + this.trans_date_from + '_' + this.trans_date_to + '.xlsx');
			// });
		},
		async excelPacked() {
			this.dataForExcel = await this.getExcelData();
			this.dataForExcel.invoiceList.forEach((value, i) => {
				value.number = i + 1;
				value.packed_dt = moment(value.packed_dt).format('MM-DD-YYYY HH:mm:ss');
			});

			let header = [
				{ key: 'number', name: 'Number', width: 10, dataType: defaultDataType.currency },
				{ key: 'bill_to_code', name: 'Bill To', width: 10 },
				{ key: 'so_dn', name: 'S/O No', width: 25 },
				{ key: 'so_date', name: 'S/O Date', width: 25 },
				{ key: 'packed_dt', name: 'Packed Time', width: 25 },
				{ key: 'ship_to_name', name: 'Ship To', width: 25 },
				{ key: 'sales_group_name', name: 'Sales Group', width: 20 },
				{ key: 'payment_term_name', name: 'Payment Type', width: 20 },
				{ key: 'delivery_type_name', name: 'Delivery Type', width: 20 },
				{ key: 'ship_charge_name', name: 'Ship Charge', width: 20 },
				{ key: 'total_quantity', name: 'Qty', width: 15, dataType: defaultDataType.currency },
				{ key: 'total_amount', name: 'Amount', width: 15, dataType: defaultDataType.number },
				{ key: 'remark2', name: 'Remark', width: 15 },
			];
			if (this.user.company_id == 'beautyplus' || this.user.company_id == 'hairplus') {
				let idx = header.findIndex(h => h.key === 'payment_term_name');
				header.splice(idx, 0, { key: 'salesman_name', name: 'Salesman', width: 20 });
			}
			exportDataExcel(this.dataForExcel.invoiceList, header, 'PackedSO_' + this.trans_date_from + '_' + this.trans_date_to);
		},
		async excelInvoice() {
			this.dataForExcel = await this.getExcelData();
			this.dataForExcel.invoiceList.forEach((value, i) => {
				value.number = i + 1;

				value.approval_dt = value.approval_dt ? moment(value.approval_dt).format('MM-DD-YYYY HH:mm:ss') : '';
				value.pt_last_print_dt = value.pt_last_print_dt ? moment(value.pt_last_print_dt).format('MM-DD-YYYY HH:mm:ss') : '';
				value.packed_dt = value.packed_dt ? moment(value.packed_dt).format('MM-DD-YYYY HH:mm:ss') : '';
				value.invoice_dt = value.invoice_dt ? moment(value.invoice_dt).format('MM-DD-YYYY HH:mm:ss') : '';

				value.delivery_type_name =
					(value.delivery_type_name || '') + (value.shipment_info_exists && (value.delivery_type_name.toUpperCase().indexOf('UPS') >= 0 || value.delivery_type_name.toUpperCase().indexOf('FEDEX') >= 0) ? ` - ${value.track_no}` : '');
			});

			let header = [
				{ key: 'number', name: 'Number', width: 10, dataType: defaultDataType.currency },
				{ key: 'bill_to_code', name: 'Bill To', width: 10 },
				{ key: 'so_dn', name: 'S/O No', width: 25 },
				{ key: 'so_date', name: 'S/O Date', width: 25 },
				{ key: 'approval_dt', name: 'Approval Time', width: 25 },
				{ key: 'pt_last_print_dt', name: 'Print Time', width: 25 },
				{ key: 'packed_dt', name: 'Packed Time', width: 25 },
				{ key: 'invoice_date', name: 'Invoice Date', width: 25 },
				{ key: 'invoice_dt', name: 'Invoice Time', width: 25 },
				{ key: 'invoice_dn', name: 'Inv. No', width: 25 },
				{ key: 'ship_to_name', name: 'Ship To', width: 25 },
				{ key: 'sales_group_name', name: 'Sales Group', width: 20 },
				{ key: 'payment_term_name', name: 'Payment Type', width: 20 },
				{ key: 'delivery_type_name', name: 'Delivery Type', width: 20 },
				{ key: 'ship_charge_name', name: 'Ship Charge', width: 20 },
				{ key: 'total_quantity', name: 'Qty', width: 15, dataType: defaultDataType.currency },
				{ key: 'total_amount', name: 'SO Amount', width: 15, dataType: defaultDataType.number },
				{ key: 'invoice_amount', name: 'Invoice Amount', width: 15, dataType: defaultDataType.number },
				{ key: 'packed_user_name', name: 'Packed User', width: 20 },
				{ key: 'remark2', name: 'Remark', width: 15 },
			];
			if (this.user.company_id == 'beautyplus' || this.user.company_id == 'hairplus') {
				let idx = header.findIndex(h => h.key === 'payment_term_name');
				header.splice(idx, 0, { key: 'salesman_name', name: 'Salesman', width: 20 });
			}
			exportDataExcel(this.dataForExcel.invoiceList, header, 'INVOICE_' + this.trans_date_from + '_' + this.trans_date_to);
		},
		sortMark: function(sort_key) {
			if (this.sort_key == sort_key) return this.sort_direction == 'ASC' ? '▲' : '▼';
			else return null;
		},
		sort(sort_key) {
			if (this.sort_key == sort_key) {
				this.sort_direction = this.sort_direction == 'ASC' ? 'DESC' : 'ASC';
			} else {
				this.sort_key = sort_key;
				this.sort_direction = 'ASC';
			}
			/*
			var skey = null;
			var sdirection = null;
			if (this.sort_key == 'print_dt') {
				skey = ['urgent_yn', 'pt_last_print_dt_str'];
				sdirection = ['desc', this.sort_direction];
			} else {
				skey = this.sort_key;
				sdirection = this.sort_direction;
			}
			console.log('sorting');
			//return _.orderBy(this.invoices, skey, sdirection);
			this.invoices = _.cloneDeep(_.orderBy(this.invoices, skey, sdirection));
			console.log(this.invoices);
*/
			this.search(false);
			//this.selectInvoices(this.page_no);
		},
		setInvoice() {
			this.search(true);
			//console.log(this.so_dn);
		},
		async printPickingTicket(batch) {
			const selectedInvoices = _.cloneDeep(this.invoices.filter(i => i.selected));
			if (selectedInvoices.length === 0) {
				this.$toast.error('Nothing Selected.');
				return;
			}

			if (batch) {
				if (await this.checkSOWithNotApprovedStatus(selectedInvoices)) return;
			}

			const param = { invoices: selectedInvoices };
			let invoiceNos = [];
			selectedInvoices.forEach(value => invoiceNos.push(value.invoice_no));

			if (await this.printPicking(invoiceNos)) {
				// apiPrintPickingTicketBatch 은 so를 packing 상태로 업데이트하는 로직
				// batch == false ? 이미 상태가 packing 이라서 so를 다시 packing 상태로 : approved 상태라서 packing 상태로 업그레이드
				if (batch) {
					let { data } = await apiPrintPickingTicketBatch(param);
					if (data.result) {
						this.$toast.success('Picking Ticket Printed Successfully');
						this.search(false);
					} else {
						this.$toast.error(data.msg);
					}
				}
			}
		},

		async checkSOWithNotApprovedStatus(invoices) {
			const param = { invoices: invoices };
			const { data } = await apiCheckSOWithNotApprovedStatus(param);

			if (data.result) {
				this.$alertify.alert('Alert', 'Exists SO(s) not in "Approved" status. Search again.');
			}

			return data.result;
		},

		async packingBox(batch) {
			const selectedInvoices = _.cloneDeep(this.invoices.filter(i => i.selected));
			if (selectedInvoices.length === 0) {
				this.$toast.error('Nothing Selected.');
				return;
			}

			if (batch) {
				if (await this.checkSOWithNotApprovedStatus(selectedInvoices)) return;
			}

			const param = { invoices: selectedInvoices };
			let invoiceNos = [];
			selectedInvoices.forEach(value => invoiceNos.push(value.invoice_no));

			if (batch) {
				let { data } = await apiPrintPickingTicketBatch(param);
				if (data.result) {
					this.$toast.success('Picking Ticket Printed Successfully');
					//this.search(false);
					await this.$router.push({ path: '/sales/boxing', query: { so_dn: selectedInvoices[0].so_dn } });
				} else {
					this.$toast.error(data.msg);
				}
			}
			//await this.$router.push({ path: '/sales/boxing', query: { so_dn: selectedInvoices[0].so_dn } });

			// this.search();
		},
		// async makePacked() { //사용 안됨
		// 	if (this.invoices.filter(i => i.selected).length == 0) {
		// 		this.$toast.error('Nothing Selected.');
		// 		return;
		// 	}

		// 	let { data } = await apiMakePackedBatch({ invoices: this.invoices.filter(i => i.selected) });
		// 	if (data.result) {
		// 		this.$toast.success('Made Packed Successfully');
		// 		this.search();
		// 	} else {
		// 		this.$toast.error(data.msg);
		// 	}
		// },
		getTime(s) {
			if (s && s.startsWith('c')) return s.substring(1);
			else return s;
		},
		getBackColorWB(inv) {
			if (inv.whole_box_count_to_pack == 0) return null;
			else if (inv.whole_box_count_packed >= inv.whole_box_count_to_pack) return 'red';
			else if (inv.whole_box_count_packed > 0) return 'lightgreen';
			else return 'yellow';
		},
		getBackColor(inv, location_code) {
			//invoice.pickup_status_map ? invoice.pickup_status_map.get(location.code)
			//console.log(inv.pickup_status_map);
			if (inv.pickup_status_map) {
				//console.log(inv.pickup_status_map);
				//if (inv.pickup_status_map.get(location_code) == 'complete') return 'red';
				var s = inv.pickup_status_map.get(location_code);
				if (s && s.substring(0, 1) == 'c') return 'red';
				else if (s) return 'yellow';
				//else return '#FFFFEA';
			} //else return 'white';

			if (inv.location_quantity_map) {
				if (inv.location_quantity_map.get(location_code)) return 'yellow';
			}
			return 'white';
		},
		// async completePacking() {
		// 	if (this.selectedInvoices.length == 0) {
		// 		return;
		// 	}

		// 	//console.log(this.selectedInvoices);
		// 	const { data } = await apiCompletePacking({
		// 		invoices: this.selectedInvoices,
		// 	});

		// 	if (data.result) {
		// 		this.$toast.success('Packing Completed');

		// 		this.selectInvoices(this.page_no);
		// 	} else {
		// 		this.$toast.error(data.msg);
		// 	}
		// },
		selectAll() {
			//console.log(this.allSelected);
			var vm = this;
			this.invoices.forEach(function(i) {
				i.selected = vm.allSelected;
			});
		},
		selectWhole() {
			//console.log(this.allSelected);
			var vm = this;
			this.invoices.forEach(function(i) {
				if (i.whole_box_exists) i.selected = vm.wholeSelected;
			});
		},
		selectDesignated() {
			//console.log(this.allSelected);
			var vm = this;
			this.invoices.forEach(function(i) {
				if (i.designated) i.selected = vm.wholeDesignated;
			});
		},
		selectInvoice(invoice, type) {
			let routeData;
			if (type == 'invoice') {
				// this.$router.push({ name: 'invoiceDetail', params: { mode: 'detail' }, query: { backUri: this.$route.fullPath, invoice_no: invoice.invoice_no } });
				routeData = this.$router.resolve({ name: 'invoiceDetail', params: { mode: 'detail' }, query: { backUri: this.uri, invoice_no: invoice.invoice_no } });
				window.open(routeData.href, 'herp_invoice');
				// this.$router.push({ name: 'soDetail', params: { mode: 'detail' }, query: { backUri: this.$route.fullPath, invoice_no: invoice.invoice_no } });
			} else {
				routeData = this.$router.resolve({ name: 'soDetail', params: { mode: 'detail' }, query: { backUri: this.uri, invoice_no: invoice.invoice_no } });
				window.open(routeData.href, 'herp_so');
			}

			//let routeData = this.$router.resolve({ name: 'invoiceDetail', params: { mode: 'detail' }, query: { backUri: this.$route.fullPath, invoice_no: invoice.invoice_no } });
			//window.open(routeData.href, '_blank');
		},
		gotoPacking(invoice) {
			let routeData = this.$router.resolve({ name: 'boxing', query: { so_dn: invoice.so_dn, from_where: 'packing_status' } });
			window.open(routeData.href, 'packing');
		},
		gotoPage(pageNo) {
			this.page_no = pageNo;
			this.selectInvoices(pageNo);
		},
		setPartner(partner) {
			//console.log(partner.code, partner.name);
			this.customer_code = partner.code;
			this.search(true);
		},
		selectPartner() {
			this.modalName = 'PartnerSelect';
			this.showModal = true;
		},
		closeModal() {
			this.showModal = false;
		},
		reset() {
			// this.sort_key = 'code';
			// this.sort_direction = 'ASC';

			this.status_code = 'O';
			if (this.user.company_id == 'beautyplus') this.trans_date_from = daysAgo(14);
			else this.trans_date_from = daysAgo(7);
			this.trans_date_to = today();
			this.sales_group_code = null;
			this.customer_code = null;
			//this.itemClass = null;
			this.itemClasses = [];
			this.allSelected = false;
			this.wholeSelected = false;
			this.wholeDesignated = false;
			this.so_dn = null;
			this.delivery_type_code = null;
			this.country_type = null;
			this.state = null;

			this.$refs.ItemClassSelectMultiS.reset();

			//this.selectInvoices();
			// this.dept_code = null;
		},
		searchByPackingStatus(status) {
			this.selected_packing_status = status;
			this.selectInvoices();
		},
		search(include_status) {
			if (this.user.company_id == 'beautyplus') {
				if (this.status_code == 'P')
					this.$nextTick(() => {
						this.$refs.change_to_packed.focus();
					});
				else if (this.status_code == 'W')
					this.$nextTick(() => {
						this.$refs.change_to_packing.focus();
					});
			}

			if (this.status_code !== 'P') this.selected_packing_status = null;
			this.allSelected = false;
			this.wholeSelected = false;
			this.wholeDesignated = false;
			this.selectInvoices();
			if (include_status) this.selectPackingInfoWithStatusWI();
			this.last_search_time = new Date();
			this.over_1_minute = false;
		},
		async selectInvoices(pageNo) {
			if (pageNo) this.page_no = pageNo;
			else this.page_no = 1;

			var param = {
				paging_yn: this.paging_yn,
				page_size: this.page_size,
				page_no: this.page_no,
				start_index: this.page_size * (this.page_no - 1),

				status_count: true,
				for_pickup: true,
				// PACKING, READY TO PACK, PICKING, PRINTED
				wh_packing_status: this.status_code === 'P' ? true : false,
				sum_by_packing_status: this.status_code === 'P' ? true : false,
				selected_packing_status: this.status_code === 'P' ? this.selected_packing_status : null,

				status_code: this.status_code,
				trans_date_from: this.trans_date_from,
				trans_date_to: this.trans_date_to,
				sales_group_code: this.sales_group_code,
				customer_code: this.customer_code,
				//class_code: this.itemClass,
				item_classes: this.itemClasses,
				delivery_type_code: this.delivery_type_code,
				country_type: this.country_type,
				ship_state: this.state,

				sort_key: this.sort_key,
				sort_direction: this.sort_direction,

				so_dn: this.so_dn,

				include_sample: true,
			};

			if (this.status_code == 'A' && !this.sort_key) {
				param.sort_key = 'approval_dt';
				param.sort_direction = 'ASC';
			}

			if (this.temp_flag != null) param.temp_flag = this.temp_flag;
			if (this.wh_not_printed && this.status_code == 'I') param.wh_not_printed = true;

			// if (this.user.company_id == 'beautyplus') {
			// 	param.so_date_from = this.trans_date_from;
			// 	param.so_date_to = this.trans_date_to;
			// 	param.normal_temp_type = 'all';
			// }

			//if ((this.status_code == 'O' || this.status_code == 'A' || this.status_code == 'P') && this.designation_type != null) param.designation_type = this.designation_type;
			if (this.designation_type != null) param.designation_type = this.designation_type;

			const { data } = await apiSelectInvoiceList(param);
			//console.log(data);
			this.invoices = data.invoiceList;
			this.list_count = data.invoicesSum.list_count; //data.list_count;

			// this.temp_invoices = data.tempInvoiceList;
			// console.log(this.temp_invoices);

			/*this.invoices.forEach(i => {
				i.pt_last_print_dt_str = moment(i.pt_last_print_dt).format('yyyy-MM-DD HH:mm:ss');
			}); */

			if (this.status_code == 'Sample') this.samples = data.sampleList;
			else this.invoices = data.invoiceList;

			this.sample_count = data.sampleCount;

			this.open_count = 0;
			this.open_sum = 0;
			this.hold_count = 0;
			this.hold_sum = 0;
			this.approved_count = 0;
			this.approved_sum = 0;
			this.packing_count = 0;
			this.packing_sum = 0;
			this.packed_count = 0;
			this.packed_sum = 0;
			this.packed_hold_count = 0;
			this.packed_hold_sum = 0;
			this.invoice_count = 0;
			this.invoice_sum = 0;
			//console.log(data.statusCount);
			for (var i = 0; i < data.statusCount.length; i++) {
				if (data.statusCount[i].status_code == 'O') {
					this.open_count = data.statusCount[i].list_count;
					if (this.user.company_id == 'newjigu') this.open_sum = data.statusCount[i].total_valid_amount_sum;
					else this.open_sum = data.statusCount[i].total_amount_sum;
				} else if (data.statusCount[i].status_code == 'H') {
					this.hold_count = data.statusCount[i].list_count;
					if (this.user.company_id == 'newjigu') this.hold_sum = data.statusCount[i].total_valid_amount_sum;
					else this.hold_sum = data.statusCount[i].total_amount_sum;
				} else if (data.statusCount[i].status_code == 'A') {
					this.approved_count = data.statusCount[i].list_count;
					if (this.user.company_id == 'newjigu') this.approved_sum = data.statusCount[i].total_valid_amount_sum;
					else this.approved_sum = data.statusCount[i].total_amount_sum;
				} else if (data.statusCount[i].status_code == 'P') {
					this.packing_count = data.statusCount[i].list_count;
					if (this.user.company_id == 'newjigu') this.packing_sum = data.statusCount[i].total_valid_amount_sum;
					else this.packing_sum = data.statusCount[i].total_amount_sum;
				} else if (data.statusCount[i].status_code == 'W') {
					this.packed_count = data.statusCount[i].list_count;
					this.packed_sum = data.statusCount[i].total_shipped_amount_sum;
				} else if (data.statusCount[i].status_code == 'PH') {
					this.packed_hold_count = data.statusCount[i].list_count;
					this.packed_hold_sum = data.statusCount[i].total_shipped_amount_sum;
				} else if (data.statusCount[i].status_code == 'I') {
					this.invoice_count = data.statusCount[i].list_count;
					this.invoice_sum = data.statusCount[i].invoice_amount_sum;
				}
			}

			if (this.status_code == 'P') {
				this.sum_by_packing_status = data.sumByPackingStatus;

				for (i = 0; i < this.invoices.length; i++) {
					var inv = this.invoices[i];

					//console.log(inv);
					//console.log(inv.invoice_no, inv.pickup_status);
					if (inv.pickup_status_str) {
						var statusList = inv.pickup_status_str.split('|');
						//console.log(inv.invoice_no);
						//console.log(inv.invoice_no, statusList);
						//var st = JSON.parse(statusList);
						//console.log(st);
						// console.log(inv.invoice_no);
						var start_dt = null;
						var start_picker_name = null;
						var end_dt = null;
						var end_picker_name = null;

						var st_map = new Map();
						//var statuses = [];
						for (var j = 0; j < statusList.length; j++) {
							var st = JSON.parse(statusList[j]);
							if (st.end_dt) {
								//st_map.set(st.location_code, 'complete');
								st_map.set(
									st.location_code,
									'c' +
										this.$moment
											.utc(st.end_dt)
											.local()
											.format('HH:mm:ss') +
										'\n' +
										st.picker_name,
								);
							} else if (st.start_dt) {
								st_map.set(
									st.location_code,
									this.$moment
										.utc(st.start_dt)
										.local()
										.format('HH:mm:ss') +
										'\n' +
										st.picker_name,
								);
							} else {
								st_map.set(st.location_code, '');
							}

							if (st.start_dt) {
								if (!start_dt || st.start_dt < start_dt) {
									start_dt = st.start_dt;
									start_picker_name = st.picker_name;
								}
							}

							if (st.end_dt) {
								if (!end_dt || st.end_dt > end_dt) {
									end_dt = st.end_dt;
									end_picker_name = st.picker_name;
								}
							}

							//statuses.push(st);
							//console.log(st);
						}
						inv.pickup_status_map = st_map;

						if (start_dt) {
							inv.start_dt_str = this.$moment
								.utc(start_dt)
								.local()
								.format('HH:mm:ss');
							inv.start_picker_name = start_picker_name;
						}

						if (end_dt) {
							inv.end_dt_str = this.$moment
								.utc(end_dt)
								.local()
								.format('HH:mm:ss');
							inv.end_picker_name = end_picker_name;
						}
						//console.log(inv.start_dt, inv.start_picker_name, inv.end_dt, inv.end_picker_name);
						//console.log(inv);
						//console.log(inv.pickup_status_map);
						//inv.pickup_statuses = statuses;
						//console.log(inv.pickup_statuses);
					}

					if (inv.location_quantity_str) {
						var locationList = inv.location_quantity_str.split('|');
						var lc_map = new Map();
						for (var k = 0; k < locationList.length; k++) {
							var lc = JSON.parse(locationList[k]);
							lc_map.set(lc.location_code, lc.quantity);
						}
						inv.location_quantity_map = lc_map;
						//console.log(inv.location_quantity_map);
					}
				}
			}
			//console.log(data.statusCount);

			//console.log(this.invoices.length);
			if (this.so_dn) {
				if ((this.status_code != 'Sample' && this.invoices.length == 0) || (this.status_code == 'Sample' && this.samples.length == 0)) {
					var search_again = true;
					if (this.open_count > 0) this.status_code = 'O';
					else if (this.approved_count > 0) this.status_code = 'A';
					else if (this.packing_count > 0) this.status_code = 'P';
					else if (this.packed_count > 0) this.status_code = 'W';
					else if (this.packed_hold_count > 0) this.status_code = 'PH';
					else if (this.invoice_count > 0) this.status_code = 'I';
					else if (this.sample_count > 0) this.status_code = 'Sample';
					else search_again = false;

					if (search_again) {
						this.search(true);
						return;
					}
				} else if (this.invoices.length == 1) this.invoices[0].selected = true;

				//this.status_code = this.invoices[0].status_code;
				//console.log(this.invoices[0].status_code);
			}

			this.$refs.paging.setPage(this.page_no, this.page_size, this.list_count);

			var uri = '/sales/packing_status?page_no=' + this.page_no + '&sort_key=' + this.sort_key + '&sort_direction=' + this.sort_direction;
			if (this.class_code) uri += '&class_code=' + this.class_code;
			if (this.status_code) uri += '&status_code=' + this.status_code;
			if (this.status_code === 'P' && this.selected_packing_status) uri += '&selected_packing_status=' + this.selected_packing_status;
			if (this.trans_date_from) uri += '&trans_date_from=' + this.trans_date_from;
			if (this.trans_date_to) uri += '&trans_date_to=' + this.trans_date_to;
			if (this.sales_group_code) uri += '&sales_group_code=' + this.sales_group_code;
			if (this.customer_code) uri += '&customer_code=' + this.customer_code;
			if (this.delivery_type_code) uri += '&delivery_type_code=' + this.delivery_type_code;
			if (this.country_type) uri += '&country_type=' + this.country_type;
			if (this.state) uri += '&state=' + this.state;
			////this.$router.replace(uri).catch(err => err);
			this.uri = uri;
			window.history.pushState({}, null, uri);
		},
		async selectPackingInfoWithStatusWI() {
			let { data } = await apiPackingInfoWithStatusWI(null, null, null);
			this.packingInfoWithStatusWI = data;
		},
		gotoPartner(code) {
			//console.log(code);
			//this.$router.push({ name: 'partnerDetail', params: { mode: 'detail' }, query: { backUri: this.$route.fullPath, code: code } });
			let routeData = this.$router.resolve({ name: 'partnerDetail', params: { mode: 'detail' }, query: { backUri: this.uri, code: code } });
			window.open(routeData.href, '_blank');
		},
		async index() {
			const { data } = await apiSoIndex();

			this.salesGroups = data.salesGroupList;
			this.locations = data.locationList;
			//console.log(this.locations);
			this.deliveryTypes = data.deliveryTypeList;
			this.states = data.stateList;
		},
		async init() {
			if (this.user.company_id == 'beautyplus') this.trans_date_from = daysAgo(14);

			await this.index();
			this.saleStatusCodes = this.$saleStatusCodes;

			this.page_size = this.$store.getters['getDefaultPageSize'];

			// this.so_date_from = today();
			// this.so_date_to = today();

			// if (this.$route.query.sort_key) this.sort_key = this.$route.query.sort_key;
			// if (this.$route.query.sort_direction) this.sort_direction = this.$route.query.sort_direction;
			// if (this.$route.query.active_yn) this.active_yn = this.$route.query.active_yn;

			// if (this.$route.query.partner_type) this.partner_type = this.$route.query.partner_type;
			// if (this.$route.query.grade) this.grade = this.$route.query.grade;
			// if (this.$route.query.state) this.state = this.$route.query.state;
			// if (this.$route.query.country) this.country = this.$route.query.country;
			if (this.$route.query.page_no) this.page_no = this.$route.query.page_no;
			if (this.$route.query.sort_key) this.sort_key = this.$route.query.sort_key;
			if (this.$route.query.sort_direction) this.sort_direction = this.$route.query.sort_direction;
			if (this.$route.query.class_code) this.class_code = this.$route.query.class_code;
			if (this.$route.query.status_code) this.status_code = this.$route.query.status_code;
			if (this.$route.query.selected_packing_status) this.selected_packing_status = this.$route.query.selected_packing_status;
			if (this.$route.query.trans_date_from) this.trans_date_from = this.$route.query.trans_date_from;
			if (this.$route.query.trans_date_to) this.trans_date_to = this.$route.query.trans_date_to;
			if (this.$route.query.sales_group_code) this.sales_group_code = this.$route.query.sales_group_code;
			if (this.$route.query.customer_code) this.customer_code = this.$route.query.customer_code;
			if (this.$route.query.delivery_type_code) this.delivery_type_code = this.$route.query.delivery_type_code;
			if (this.$route.query.country_type) this.country_type = this.$route.query.country_type;
			if (this.$route.query.state) this.state = this.$route.query.state;

			await this.selectInvoices(this.page_no);
			await this.selectPackingInfoWithStatusWI();
			this.last_search_time = new Date();
		},
		async printPicking(invoiceNos) {
			let { data } = await apiPickingPrintDataList(objectToFormData({ invoiceNos: invoiceNos }));
			if (data.result_code === 'success') {
				const reportTemplate = await getMrtFile(companyMrtUrl('Picking'));
				const report = new Report(reportTemplate, data.data, 'Picking', PrintType.List);
				this.$store.commit('setReport', report);
				return true;
			} else {
				this.$toast.error(data.errorSoList + ' An error has occurred.');
				return false;
			}
		},

		async wholeTicketPrint() {
			let selectedInvoices = this.invoices.filter(i => i.selected);
			if (selectedInvoices.length === 0) {
				this.$toast.error('Nothing Selected.');
				return;
			}

			if (!selectedInvoices.some(i => !!i.whole_box_exists)) {
				this.$toast.error('Nothing Including Whole Ticket');
				return;
			}

			let invoiceNos = selectedInvoices.filter(i => !!i.whole_box_exists).map(i => i.invoice_no);
			const { data } = await apiPickingPrintDataList(objectToFormData({ invoiceNos: invoiceNos }));
			const reportTemplate = await getMrtFile(companyMrtUrl('WholeBoxTicket'));
			const report = new Report(reportTemplate, data.data, 'WholeBoxTicket', PrintType.List);
			this.$store.commit('setReport', report);
		},
		timerOn() {
			if (this.last_search_time && (new Date() - this.last_search_time) / 1000 > 60) {
				this.over_1_minute = true;
				//console.log('over one minute');
				this.$forceUpdate();
			} else {
				this.over_1_minute = false;
				//console.log('not over one minute');
			}

			if (this.auto_refresh) {
				//console.log('auto refresh');
				this.search(true);
			}
		},
		setAutoRefresh() {
			//console.log(this.auto_refresh);
			this.$session.set('auto_refresh', this.auto_refresh);
		},
	},
	created() {
		//this.$store.sideIndex = 3;
		this.$store.commit('setSideIndex', 3);
		//this.$store.selectedMenu = 'nav_li_6';
		this.$store.commit('setSelectedMenu', 'nav_li_packing_status');
		this.$store.commit('setSubTitle', 'Sales -> Packing Status');

		this.auto_refresh = this.$session.get('auto_refresh');

		//this.selectInvoices();
		//console.log(this.profile.use_temp_flag);
		if (this.profile.use_temp_flag == 'Y') {
			this.$alertify.alert('Alert', 'Select "Ship From" first.');

			if (this.user.temp_flag) {
				this.auto_refresh = true;
				this.temp_flag = 1;
			} else if (this.user.user_id == 'rejoice') {
				this.temp_flag = 0;
			}
		}

		this.init();

		//this.invoice.invoice_date = this.$moment(new Date()).format('MM-DD-YYYY');
		//this.invoice.so_date = today();
		//console.log(this.$moment(new Date()).format('MM-DD-YYYY HH:mm:ss'));

		//console.log(this.$session.get('time_zone'));
		//this.$moment.tz.setDefault(this.$session.get('time_zone'));
	},
	mounted() {
		inputSelectOnClick();
		//makeTableResizable();
		var vm = this;

		this.interval = setInterval(function() {
			//vm.search();
			vm.timerOn();
		}, 60000);
	},
	beforeDestroy() {
		//console.log('before destroy');
		clearInterval(this.interval);
	},
};
</script>

<style></style>
